<template>
  <div>
    <div class="all_body">
      <!-- banner -->
      <div class="banner">
          <el-carousel indicator-position="outside" >
            <el-carousel-item v-for="(items,index) in banner_list" :key="index">
                <img :src="items.cms_pic" class="banner-img"/>
            </el-carousel-item>
          </el-carousel>
      </div>

      <!-- 金鸡讲堂 -->
      <div class="classroom">
        <div class="classroom_top">
          <div class="classroom_line"></div>金鸡讲堂
        </div>
        <div class="class_room_middle">
          <div class="class_room_content" v-for="(items,index) in manager_list.slice(0,4)"  :key="index">
            <div class="class_room_content_img" @click="getVideoDetail(items.v_id)">
                <img :src="items.cover" class="banner-img"/>
            </div>
            <div class="class_room_content_title">{{items.title}}</div>
            <div class="class_room_content_bottom">
              <img :src="play" class="play" />
              <div class="class_room_content_font">{{items.view}}</div>
              <img :src="icon" class="icon" />
              <div class="class_room_content_font">38</div>
            </div>
          </div>
        </div>
      </div>

      <!-- 价格行情 -->
      <!-- <div class="market">
        <div class="classroom_top">
          <div class="classroom_line"></div>价格行情
        </div>
        <div class="market-content" >
          <div class="market-left"  >
            <iframe :src="market" id="mobsf"  frameborder="0" ></iframe>
          </div>
          <div class="market-right">
              <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="蛋价" name="first"></el-tab-pane>
                <el-tab-pane label="淘汰鸡" name="second"></el-tab-pane>
              </el-tabs>
              <div class="table_title">
                  <span class="area">报价地区</span>
                  <span class="sell">规格</span>
                  <span class="today">今日</span>
                  <span class="yesterday">昨日</span>
                  <span class="spread">趋势</span>
              </div>
              <div class="market_list" >
                    <div v-for="(items,index) in market_list" :key="index">
                        <ul v-for="(q,index) in items.list" :key="index">
                            <li class="area">{{q.area}}</li>
                            <li class="sell">{{q.shell_color}}{{q.weight}}</li>
                            <li class="today">{{q.today}}</li>
                            <li class="yesterday">{{q.yesterday}}</li>
                            <li class="spread">
                                <div class="spread_type_0" v-if="q.type == 0">
                                    ± {{q.spread}}
                                </div>
                                <div class="spread_type_1" v-else-if="q.type == 1">
                                    + {{q.spread}}
                                </div>
                                <div class="spread_type_2" v-else>
                                    - {{q.spread}}
                                </div>
                            </li>
                        </ul>
                    </div>
              </div>
              <div class="market-more">
                <router-link tag='a' :to="'/MarketInfo'" >点击查看更多报价</router-link>
              </div>
          </div>
        </div>
      </div> -->

      <!-- 新闻资讯 -->
      <div class="news">
        <div class="news_content">
          <div class="news_content_top">
            <div class="news_content_line"></div>新闻资讯
          </div>
          <div class="classroom_middle_line"></div>
          <div class="news_middle">
            <div class="news_middle_ul">
              <div class="news_middle_ul_content" v-for="(items,index) in news_list" :key="index">
                <div class="news_middle_dian"></div>
                <div class="news_middle_font" @click="getDetail(items.cms_id)">{{items.cms_title}}</div>
              </div>
            </div>
            <div class="news_more">
              <router-link tag='a' :to="'/News/2'" >更多</router-link>
            </div>
          </div>
        </div>
        <div class="news_content">
          <div class="news_content_top">
            <div class="news_content_line"></div>养殖宝典
          </div>
          <div class="classroom_middle_line"></div>
          <div class="news_middle">
            <div class="news_middle_ul">
              <div class="news_middle_ul_content" v-for="(items,index) in news_list100" :key="index">
                <div class="news_middle_dian"></div>
                <div class="news_middle_font" @click="getDetail(items.cms_id)">{{items.cms_title}}</div>
              </div>
            </div>
            <div class="news_more">
              <router-link tag='a' :to="'/News/100'" >更多</router-link>
            </div>
          </div>
        </div>
        <div class="news_content">
          <div class="news_content_top">
            <div class="news_content_line"></div>微周报
          </div>
          <div class="classroom_middle_line"></div>
          <div class="news_middle">
            <div class="news_middle_ul">
              <div class="news_middle_ul_content" v-for="(items,index) in news_list78" :key="index">
                <div class="news_middle_dian"></div>
                <div class="news_middle_font" @click="getDetail(items.cms_id)">{{items.cms_title}}</div>
              </div>
            </div>
            <div class="news_more">
              <router-link tag='a' :to="'/News/78'" >更多</router-link>
            </div>
          </div>
        </div>
      </div>

      <!-- 公司信息 -->
      <div class="company">
        <div class="company_content">
          <div class="company_left">
              <img :src="company_img" class="company_img">
          </div>
          <div class="company_right">
            <div class="company-phone">400-656-7018</div>
            <div class="company-name">{{company.name}}</div>
            <div class="company-address">{{company.address}}</div>
            <div class="company_email">E-mail:{{company.email}} 邮编：{{company.zipcode}}</div>
          </div>
        </div>
      </div>
    </div>


  </div>
</template>

<script>
import {getBanner_pc, quotationLists, outQuotationLists, videoHot, newsData, getContact} from '../api/api'

export default {
  name: "Index",
  data() {
    return {
      play: "./static/img/play.png",
      icon: "./static/img/icon.png",
      market: "https://api.rls.danjiguanjia.com/indexpc?type=month",
      company_img: './static/img/company.png',
      star: './static/img/star.jpg',
      banner_list: [],
      manager_list: [],
      news_list: [],
      news_list100:[],
      news_list78: [],
      activeName: 'first',
      market_list: [],
      company: ""
    };
  },
  mounted(){
      /**
      * iframe-宽高自适应显示
      */
      // function changeMobsfIframe(){
      //   const mobsf = document.getElementById('mobsf');
      //   const deviceWidth = document.body.clientWidth;
      //   const deviceHeight = document.body.clientHeight;
      //   mobsf.style.width = 100 + '%'; //数字是页面布局宽度差值
      //   mobsf.style.height = 100 + '%'; //数字是页面布局高度差
      //   //console.log(mobsf.style.width,mobsf.style.height)
      // };

      // changeMobsfIframe();

      window.onresize = function(){
        changeMobsfIframe()
      };
      getBanner_pc().then(res => {
          //console.log(res.data)
          this.banner_list = res.data;
      });
      videoHot({
          ticket : this.$store.state.ticket
        }).then(res => {
          //console.log(res.data.data)
          this.manager_list = res.data.data;


      });
      quotationLists({
          page: 1
      }).then(res => {
          this.market_list = res.data.lists;
          //console.log(res.data)
      });
      newsData({
          page: 1,
          category: 2,
          ticket: this.$store.state.ticket
      }).then(res => {
          this.news_list = res.data.data
      })
      newsData({
          page: 1,
          category: 100,
          ticket: this.$store.state.ticket
      }).then(res => {
          this.news_list100 = res.data.data
      })
      newsData({
          page: 1,
          category: 78,
          ticket: this.$store.state.ticket
      }).then(res => {
          this.news_list78 = res.data.data
      })
     getContact({}).then(res => {
       this.company = res.data
       //console.log(res.data)
     })
  },
  methods: {
      handleClick(tab, event) {
        if(tab.name == 'first'){
            quotationLists({
                page: 1
            }).then(res => {
                this.market_list = res.data.lists;
                //console.log(res.data)
            });
        }
        if(tab.name == 'second'){
            outQuotationLists({
                page: 1
            }).then(res => {
                this.market_list = res.data.lists;
                //console.log(res.data)
            });
        }
      },

    getDetail(id){
      this.$router.push('/NewsDetail/'+ id)
    },

    getVideoDetail(id){
      this.$router.push('/videoDetail/'+ id)
    }
  }
};
</script>

<style>

.all_body {
  width: 100%;
  padding-left: 11%;
  padding-right: 10%;
}
.banner {
  width: 100%;
  height: 500px;
  margin-top: 30px;
}
.banner .el-carousel__container{
  height: 500px;
}
.banner-img{
    width: 100%;
    height: 100%;
}
.classroom {
  margin-top: 55px;
}
.classroom_top {
  display: flex;
  align-items: center;
  height: 32px;
  line-height: 32px;
  font-size: 34px;
  color: #000000;
}
.news_content_top{
  display: flex;
  align-items: center;
  height: 29px;
  line-height: 29px;
  font-size: 30px;
  color: #000000;
}
.classroom_line {
  width: 6px;
  height: 40px;
  background: #55b233;
  margin-right: 11px;
}
.news_content_line{
  width: 6px;
  height: 36px;
  background: #55b233;
  margin-right: 11px;
}
.class_room_middle {
  display: flex;
  align-items: center;
  width: 100%;
  overflow: hidden;
}
.class_room_content {
  width: 25%;
  margin: 22px 0;
  margin-right: 20px;
  cursor: pointer;
}
.class_room_content:last-child{
  width: 25%;
  margin: 22px 0;
  margin-right: 0px;
}

.class_room_content_img {
  width: 100%;
  height: 210px;
}
.class_room_content_title {
  margin-top: 22px;
  height: 18px;
  line-height: 19px;
  font-size: 18px;
  color: #000000;
  overflow: hidden;
}
.class_room_content_bottom {
  display: flex;
  margin-top: 20px;
  align-items: center;
}
.play {
  width: 19px;
  height: 19px;
  line-height: 19px;
  margin-top: 0;
  opacity: 0.3;
  margin-right: 8px;
}
.icon {
  width: 20px;
  height: 19px;
  line-height: 19px;
  opacity: 0.2;
  margin-right: 8px;
  margin-left: 20px;
  margin-top: 0;
}
.market {
  margin-top: 40px;
}
.market-content {
  display: flex;
  margin-top: 29px;
  height: 485px;
  background: #f8f8f8;
  padding: 6px;
}
.market-left {
  width: 60%;
  height: 480px;
  margin-right: 22px;
  padding-bottom: 8px;
}
.market-right {
  width: 40%;
  color: #000000;
}
.iframe_up{
  position: absolute;
  top: 0;
  left: 0;
  z-index: 99;
  width: 100%;
  height: 50%;
  background: #19af00;
}
.marker-iframe {
  position: relative;
  width: 100%;
  height: 100%;
  border: none;
}
.news {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-top: 58px;
}
.news_content {
  width: 33%;
  margin: 22px 20px 22px 0;
  /* margin-right: 10px; */
  /* padding-right: 20px; */
}
.news_content:last-child {
  width: 33%;
  margin: 22px 0px 22px 0;
}
.classroom_middle_line {
  widows: 100%;
  height: 2px;
  background: #dcdcdc;
  margin-top: 21px;
}
.news_middle {
  position: relative;
  width: 100%;
  height: 340px;
  background: #f8f8f8;
  margin-top: 13px;
  overflow: hidden;
}

.news_middle_ul{
  width: 90%;
  height: 80%;
  font-size: 18px;
  font-weight: 400;
  color: #000000;
  white-space:nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  margin-top: 20px;
}
.news_middle_ul_content{
  display: flex;
  align-items: center;
  height: 20px;
  line-height: 20px;
  padding: 15px 0;
  font-size: 18px;
  font-weight: 400;
  color: #000000;
}
.news_more {
  position: absolute;
  bottom: 21px;
  right: 27px;
  height: 16px;
  font-size: 16px;
  font-weight: 400;
}
.news_more a {
  color: #0066ff;
  text-decoration: none;
}
.company {
  margin-top: 60px;
  margin-bottom: 100px;
}
.company_content {
  display: flex;
  height: 394px;
}
.company_left {
  width: 960px;
  height: 394px;
  margin-right: 50px;
}
.company_img{
    width: 100%;
    height: 100%;
}
.company-phone {
  margin-top: 200px;
  height: 38px;
  line-height: 38px;
  font-size: 53px;
  font-weight: 400;
  color: #55b233;
}
.company-name {
  margin-top: 38px;
  height: 26px;
  line-height: 26px;
  font-size: 28px;
  font-weight: 400;
  color: #000000;
}
.company-address {
  height: 40px;
  font-size: 16px;
  font-weight: 400;
  color: #000000;
  margin-top: 20px;
}
.company_email {
  height: 17px;
  line-height: 17px;
  font-size: 16px;
  font-weight: 400;
  color: #000000;
  margin-top: 16px;
}

.el-carousel__item h3 {
    color: #475669;
    font-size: 18px;
    opacity: 0.75;
    line-height: 300px;
    margin: 0;
  }

  .el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
  }

  .el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
  }
  .market-right .el-tabs__item{
    font-size: 20px;
  }
  .market-right .el-tabs__item.is-active {
    color: #22AC38;
  }
  .market-right .el-tabs__item:hover{
    color: #22ac38 !important;
  }
  .market-right .el-tabs__active-bar {
      background-color: #22AC38;
  }
  .table_title{
      display: flex;
      background: #e9e9e9;
      height: 25px;
      line-height: 25px;
      padding-left: 8px;
  }
  .table_title span{
      height: 25px;
      line-height: 25px;
      font-size: 18px;
      color: #7a7a7a;
      padding-top: 1px;;
  }
  .area{
      text-align: left;
      width: 20%;
  }
  .sell{
      text-align: center;
      width: 20%;
  }
  .today{
      text-align: center;
      width: 25%;
  }
  .yesterday{
      text-align: center;
      width: 10%;
  }
  .spread{
      text-align: center;
      width: 25% ;
  }
  .market_list{
      height: 350px;
      overflow: hidden;
  }
  .market_list ul{
        /* margin-top: 12px; */
        padding: 10px 0 9px 8px;
        border-bottom: 1px solid #D5D5D5;
        overflow: hidden;
  }
  .market_list ul li{
        float: left;
        color: #000000;
        list-style-type:none;
        font-size: 16px;
  }
    .spread_type_0{
        width: 70px;
        height: 20px;
        line-height: 20px;
        margin: 0 auto;
        font-size: 13px;
        color: #ffffff;
        background: #a8a8a8;
    }
    .spread_type_1{
        width: 70px;
        height: 20px;
        line-height: 20px;
        margin: 0 auto;
        font-size: 13px;
        color: #ffffff;
        background: #ff0000;
    }
    .spread_type_2{
        width: 70px;
        height: 20px;
        line-height: 20px;
        margin: 0 auto;
        font-size: 13px;
        color: #ffffff;
        background: #19af00;
    }
    .market-more{
        display: flex;
        align-items: center;
        justify-content: center;
        height: 40px;
        width: 100%;
    }
    .market-more a{
        text-align: center;
        text-decoration: none;
        font-size: 16px;
        color:rgba(0,102,255,1);
    }
    .news_middle_dian{
      width: 5px;
      height: 5px;
      background: #A0A0A0;
      border-radius:3px;
      margin-left: 20px;
    }
    .news_middle_font{
      width: 100%;
      margin-left: 30px;
      overflow: hidden;
      white-space:nowrap;
      text-overflow: ellipsis;
      cursor: pointer;
    }
    .class_room_content_font{
      font-size: 14px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Index.vue